import anime from "animejs";

export default {
    name: 'footer',
    component() {
        return {
            openNewsletterPopup: false,
            email: "",
            newsletter: {
                email: "",
                gdpr: "",
                success: false,
            },
            easing: "cubicBezier(0.4, 0, 0.2, 1)",

            init() {
                if(window.innerWidth < 1000) {
                    this.openNewsletterPopup = true;
                }
                
                if (window.innerWidth > 999) {
                    this.setFooterOverlay();
                }
                
                window.addEventListener("resize", () => {
                    if(window.innerWidth < 1000) {
                        this.openNewsletterPopup = true;
                    } else {
                        this.openNewsletterPopup = false;
                    }

                    if (window.innerWidth > 999) {
                        this.setFooterOverlay();
                    }
                });

                const subscribeSuccess = new URLSearchParams(window.location.search).get('customer_posted');

                const alreadySubscribed = new URLSearchParams(window.location.search).has('contact[tags]');
                if(alreadySubscribed) {
                  this.newsletter.success = true;                  
                  this.openNewsletterPopup = true;
                }

                if(subscribeSuccess == 'true') {
                    this.openNewsletterPopup = true;
                }
            },



            setFooterOverlay() {
                setTimeout(() => {                    
                    let footerHeight = document
                        .querySelector("[data-footer]")
                        .getBoundingClientRect().height;
    
                    let footerOverlay = document.querySelector("[data-footer-overlay]");
                    footerOverlay.style.paddingBottom = `${footerHeight}px`;
                }, 100);
            },
            
            validateNewsletter() {
                let emailInput = document.querySelector("[data-newsletter-email]");
                let gdprInput = document.querySelector("[data-newsletter-gdpr]");
                let valid = true;
        
                if (
                    this.newsletter.email !== "" &&
                    this.validateEmail(this.newsletter.email) && this.newsletter.gdpr == true
                ) {
                    gdprInput.style.borderColor = "";
                    emailInput.style.borderColor = "";

                } else {
                    if(this.newsletter.email == "" || this.validateEmail(this.newsletter.email) == null) {
                      emailInput.style.borderColor = "#F71C22";
                    } else {
                      emailInput.style.borderColor = "";
                    }

                    if(this.newsletter.gdpr != true) {
                        gdprInput.style.borderColor = "#F71C22";
                    } else {
                        gdprInput.style.borderColor = "";
                    }

                    valid = false;
                }
        
                if (valid) {
                    this.submitNewsletter();
                }
            },

            submitNewsletter() {
              setTimeout(() => {
                  this.newsletter.success = true;
              }, "500");

               const form = document.querySelector("form[id='contact_form']");
               form.submit();

            },

            validateEmail(email) {
              return String(email)
                  .toLowerCase()
                  .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  );
            },
        }
    }
}